import { currentAppEnvConfigs } from '@/configs/env'

export * from './url'

// Safely parse JSON without throwing an error
export function safeJsonParse<T>(json: string, defaultValue: T | null = null): T | null {
  try {
    return JSON.parse(json) as T
  } catch (e) {
    return defaultValue
  }
}
export const getCdcWebSignupLink = () => `https://${currentAppEnvConfigs.cdcWebDomain}/signup`

export const getCdcAppDownloadLink = () => 'https://crypto.onelink.me/xxPI/one'

export function gotoCdcWebSignupPage() {
  window.location.href = getCdcWebSignupLink()
}

export function gotoCdcWebSignupPageInExternalBrowser() {
  window.open(getCdcWebSignupLink(), '_blank')
}

export function gotoCdcAppDownloadPage() {
  window.location.href = getCdcAppDownloadLink()
}

export const isObject = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null && !Array.isArray(value)
